import project from '@/api/report/project'
import { baseState, baseMutations } from '@/store/mixins'
import moment from 'moment'

export const state = {
    ...baseState,
    date_from: moment().format('DD-MM-YYYY'),
    date_to: moment().format('DD-MM-YYYY')
}

export const getters = {}

export const mutations = {
    ...baseMutations,
    SET_DATE_FROM(state, date) {
        state.date_from = date
    },
    SET_DATE_TO(state, date) {
        state.date_to = date
    }
}

export const actions = {
    // generate daily item used pdf
    dailyItemUsed(context, attributes = {}) {
        return project.dailyItemUsed({
            params: Object.assign(
                {
                    date_from: context.state.date_from,
                    date_to: context.state.date_to
                },
                attributes
            )
        })
    },
    dailyItemUsedExcel(context, data) {
        return project.dailyItemUsedExcel(
            Object.assign(
                {
                    date_from: context.state.date_from,
                    date_to: context.state.date_to
                },
                data
            )
        )
    },
    dailyTaskUpdate(context, attributes = {}) {
        return project.dailyTaskUpdate({
            params: Object.assign(
                {
                    date_from: context.state.date_from,
                    date_to: context.state.date_to
                },
                attributes
            )
        })
    },
    dailyTaskUpdateExcel(context, data) {
        return project.dailyTaskUpdateExcel(
            Object.assign(
                {
                    date_from: context.state.date_from,
                    date_to: context.state.date_to
                },
                data
            )
        )
    },
    getProject(context, payload) {
        return project.project(payload)
    },
    getSite(context, payload) {
        return project.site(payload)
    },
    getProduct(context, payload) {
        return project.product(payload)
    },
    getCategory(context, payload) {
        return project.category(payload)
    },
    getOwner(context, payload) {
        return project.owner(payload)
    },
    getStatus(context, payload) {
        return project.status(payload)
    },
    getCustomer(context, payload) {
        return project.customer(payload)
    }
}
